import { Student, Class, Grade, Lesson, ContactBook } from '@/plugins/api'
import alert from '@/plugins/alert'
import loading from '@/plugins/loading'

export default {
  namespaced: true,
  state: {
    classNo: 0,
    studentNo: 0,
    grades: [],
    classes: [],
    students: [],
    sendPostResult: {},
    lessons: [],
    singleClass: {}
  },
  actions: {
    async fetchAllSchoolData({ commit }) {
      const [classNo, studentNo] = await Promise.all([
        Class.count({ status: 'running' }),
        Student.count({ status: 'active' })
      ])
      commit('changeState', { classNo, studentNo })
    },
    async fetchGradeData({ commit }) {
      try {
        let grades = await Grade.fetch({ _sort: 'gradeNumber:asc' })
        const promises = grades.map(async g => {
          const classNo = await Class.count({ grade: g.id, status: 'running' })
          const studentNo = await Student.count({ grade: g.id, status: 'active' })
          g.classNo = classNo
          g.studentNo = studentNo
          return g
        })
        grades = await Promise.all(promises)
        commit('changeState', { grades })
      } catch (error) {
        alert.error(error)
      }
    },
    async fetchClassData({ commit }, params) {
      try {
        const classes = await Class.fetch({ ...params, _sort: 'title:asc' })
        commit('changeState', { classes })
      } catch (error) {
        alert.error(error)
      }
    },
    setPostResult({ state }, isSuccess) {
      state.sendPostResult = { isSuccess }
    },
    // TODO: delete other unused fetch
    async fetchLessons({ commit }, params) {
      const lessons = await Lesson.fetch(params)
      commit('changeState', { lessons })
    },
    async fetchOneClass({ commit }, id) {
      const singleClass = await Class.fetchOne(id)
      commit('changeState', { singleClass })
    },
    async sendDiligence(_, data) {
      loading.active = true
      try {
        await ContactBook.sendDiligence(data)
        alert.success('Gửi thông báo điểm danh thành công')
      } catch (error) {
        alert.error(error)
      } finally {
        loading.active = false
      }
    }
  },
  mutations: {
    setSelectedStudent(state, data) {
      state.students = data
    },
    deleteStudent(state, studentId) {
      const studentIndex = state.students.findIndex(student => student.id === studentId)
      if (studentIndex !== -1) {
        state.students.splice(studentIndex, 1)
      }
    }
  },
  getters: {
    allSchoolItems: ({ classNo, studentNo }) => {
      return [{ title: 'Toàn trung tâm', classNo, studentNo }]
    },
    students: state => state.students
  }
}
